import React from 'react';
import {useDispatch} from 'react-redux';
import {View, Text, TouchableOpacity, Image} from 'react-native';

import FastImage from 'src/Utils/FastImage';
import {setCurrentHunt} from 'src/Redux/reducers/hunts.reducer.js';
import {cloudFlareOptimizeImage} from '../Utils/helpers';

const HuntListCard = ({
  hideNavigate,
  disableTouch,
  height = 150,
  replaceReviewsWithText,
  index,
  width,
  extraMargin = 0,
  navText,
  descriptionOverride,
  fallbackImage,
  handlePress,
  hunt,
}) => {
  const dispatch = useDispatch();

  var {
    name = '',
    city = '',
    star_rating,
    total_reviews,
    huntMediumPhotoURL,
    hunt_type,
  } = hunt;
  if (hunt?.navText) {
    navText = hunt?.navText;
  }

  huntMediumPhotoURL = cloudFlareOptimizeImage(huntMediumPhotoURL);

  console.log({huntMediumPhotoURL});
  const barHunt = hunt_type == 'barHunt';
  var description = 'SCAVENGER HUNT';
  if (barHunt) {
    description = 'BAR HUNT AND CRAWL';
  } else if (hunt_type == 'artWalk') {
    description = 'ART WALK SCAVENGER HUNT';
  }
  const numberStars =
    !total_reviews || parseInt(total_reviews) < 10
      ? 5
      : Math.round(parseFloat(star_rating) * 10) / 10;
  const reviewText =
    !total_reviews || parseInt(total_reviews) < 10
      ? 'New Hunt!'
      : `${numberStars} Stars (${total_reviews} Reviews)`;

  const handleCardPress = () => {
    const setHunt = {...hunt};

    //setting ghosts tours to have a route_id, route_id 1
    dispatch(setCurrentHunt(setHunt));
    handlePress?.();
  };

  return (
    <TouchableOpacity
      activeOpacity={0.85}
      style={{
        backgroundColor: global?.color?.gray3,
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        overflow: 'hidden',
      }}
      onPress={handleCardPress}
      disabled={!!disableTouch}>
      <Image
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          height,
          width,
        }}
        // eslint-disable-next-line no-use-before-define
        source={fallbackImage || backupImages[(index || 0) % 7]}
        resizeMode={FastImage?.resizeMode?.cover}
      />

      {!!huntMediumPhotoURL && (
        <Image
          resizeMode={FastImage?.resizeMode?.cover}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: 290,
          }}
          source={{uri: huntMediumPhotoURL}}
        />
      )}
      <View
        style={{
          position: 'absolute',
          paddingTop: 37,
          paddingBottom: 35,
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: global?.color?.gray3_30,
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <Text
          style={{
            marginTop: extraMargin,
            fontSize: descriptionOverride ? 20 : 14,
            marginBottom: descriptionOverride ? 10 : 0,
            color: 'white',
            fontFamily: 'Alternate Gothic No3 D',
          }}>
          {descriptionOverride
            ? descriptionOverride
            : `${city.toUpperCase?.()} ${description}`}
        </Text>
        <Text
          style={{
            fontSize: 26,
            color: 'white',
            fontFamily: 'Alternate Gothic No3 D',
            textAlign: 'center',
          }}>
          {name.toUpperCase?.()}
        </Text>
        {!replaceReviewsWithText && (
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
            }}>
            <Text
              style={{
                fontSize: 18,
                color: 'white',
                fontFamily: 'Alternate Gothic No3 D',
              }}>
              {reviewText}
            </Text>
          </View>
        )}
        {!!replaceReviewsWithText && (
          <Text
            style={{
              fontSize: 20,
              color: 'white',
              fontFamily: 'Alternate Gothic No3 D',
            }}>
            {replaceReviewsWithText.toUpperCase?.()}
          </Text>
        )}
      </View>
      {!hideNavigate && (
        <View
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: 30,
            backgroundColor: global?.color?.gray3_50,
            alignItems: 'center',
            alignContent: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
            opacity: 1,
          }}>
          <Text
            style={{
              fontSize: 16,
              color: 'white',
              fontFamily: 'Alternate Gothic No3 D',
              textAlign: 'center',
            }}>
            {(navText || 'VIEW COURSE!') +
              (global?.HermesInternal != null ? '!' : '')}
          </Text>
        </View>
      )}
    </TouchableOpacity>
  );
};

// random thumb photos of cities in the USA
const backupImages = [
  {
    uri: cloudFlareOptimizeImage(
      'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648579273_medium.jpg',
    ),
  },
  {
    uri: cloudFlareOptimizeImage(
      'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648579299_medium.jpg',
    ),
  },
  {
    uri: cloudFlareOptimizeImage(
      'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648579314_medium.jpg',
    ),
  },
  {
    uri: cloudFlareOptimizeImage(
      'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648579326_medium.jpg',
    ),
  },
  {
    uri: cloudFlareOptimizeImage(
      'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648579338_medium.jpg',
    ),
  },
  {
    uri: cloudFlareOptimizeImage(
      'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648579351_medium.jpg',
    ),
  },
  {
    uri: cloudFlareOptimizeImage(
      'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648579362_medium.jpg',
    ),
  },
];

export default HuntListCard;
